import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { applyPageMetadata } from '../../utils/pageMetadata';

function PageStatus({ status }) {
    const { pathname } = useLocation();
    const missing = status === 404;
    useEffect(() => {
        applyPageMetadata(null, pathname, { status });
    }, [pathname, status]);
    return (
        <main className="muulti-container">
            <h1>{missing ? '404 — Page not found' : 'This page is temporarily unavailable'}</h1>
            <p>{missing ? 'This page does not exist or may have been removed.' : 'The page could not be loaded right now. Please try again shortly.'}</p>
            <p><Link to="/">Return home</Link> · <Link to="/muulti-directory">Explore creators</Link></p>
        </main>
    );
}

export function NotFoundPage() { return <PageStatus status={404} />; }
export function PageUnavailable() { return <PageStatus status={503} />; }
